<template>
  <div class="scroll-to-top">
    <div
        class="scroll-to-top-button"
        @click="toTop"
    >
      <FontAwesomeIcon :icon="faArrowUpToLine"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowUpToLine } from '@fortawesome/pro-light-svg-icons';

library.add(faArrowUpToLine);

const toTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
</script>

<style lang="scss">
@import "src/scss/component-helpers";
.scroll-to-top {
  position: fixed;
  cursor: pointer;
  right: 0.625rem;
  z-index: 99;
  top: 72%;
  box-shadow: 0 2px 4px #00000026;
  border-radius: 65px;

  .scroll-to-top-button{
    width: 2.5rem;
    height: 2.5rem;
    background-color: #E7F1F5;
    border-radius: 65px;

    svg {
      width: 0.938rem;
      height: 1.313rem;
      margin: 11.5px 12.5px 7.5px;
    }
  }
}
</style>
